import axios from 'axios';
import store from '@/store'
import getAccessToken from '@/helpers/accessTokenHelper'

let generalRequest = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true,
});

let privateRequest = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        'Content-Type': 'application/json'
    },
});

privateRequest.interceptors.request.use(function (config) {
    config.headers['Authorization'] = `Bearer ${store.state.auth.accessToken || ""}`;
    return config;
})

// response interceptor
// getting access token through refresh token and retrying previous request
privateRequest.interceptors.response.use(response => response, async function (error) {
    const prevRequest = error?.config;
    if (error.response.status === 401 && error.response?.data?.message === 'access token expired' && !prevRequest?.sent) {
        try {
            prevRequest.sent = true;
            const token = await getAccessToken();
            prevRequest.headers['Authorization'] = `Bearer ${token}`;
            await store.methods.transformAndSetUser({ accessToken: token });
            await store.methods.saveState();
            return privateRequest(prevRequest);
        } catch (error) {
            console.error(error);
            store.methods.removeState();
            window.refresh();
        }
    };
    return Promise.reject(error);
})

export default {
    generalRequest,
    privateRequest
};

